export const CURRENCY_ADJUSTMENT_TYPES = new Map([
  [1, 'arrow-up'],
  [2, 'arrow-down']
])

export const CURRENCY_ADJUSTMENT_TYPE_COLORS = new Map([
  [1, 'green'],
  [2, 'red']
])

export const CURRENCY_TYPES = new Map([
  [1, 'softCurrency'],
  [2, 'hardCurrency']
])
export const CURRENCY_TYPES_NAMES = new Map([
  [1, 'Soft'],
  [2, 'Hard']
])

export const REDEMPTION_STATUSES = new Map([
  [1, 'NEW'],
  [2, 'IN PROGRESS'],
  [3, 'REDEEMED']
])
export const REDEMPTION_STATUSES_NAMES = new Map([
  ['NEW', 1],
  ['IN PROGRESS', 2],
  ['REDEEMED', 3]
])

export const ACHIEVEMENTS_TYPES = new Map([
  [0, 'TRY_HARD'],
  [1, 'ALL_SCHEDULED'],
  [2, 'CHAMPION'],
  [3, 'CLINICAL_PATHWAY_SUCCESS'],
  [4, 'EVERYTHING_IS_UNDER_CONTROL'],
  [5, 'KEEP_IN_TOUCH'],
  [6, 'KNOWLEDGE'],
  [7, 'SETUP_CLINICAL_APPOINTMENTS'],
  [8, 'TRENDY']
])

export const DEFAULT_MEDAL = 'BRONZE'

export const REWARD_MODULE_TYPES = new Map([
  [1, 'Clinical Pathway'],
  [2, 'Measurement'],
  [3, 'Medication'],
  [4, 'Education'],
  [5, 'Appointment'],
  [6, 'Combined'],
  [7, 'Chat']
])
